import * as Phaser from "phaser";

export const petActions = {
  emitter: new Phaser.Events.EventEmitter(),

  soapUsed: () => {
    petActions.emitter.emit("soapUsed");
  },

  ballPlayed: () => {
    petActions.emitter.emit("ballPlayed");
  },

  foodEaten: () => {
    petActions.emitter.emit("foodEaten");
  },

  poopEmitted: () => {
    petActions.emitter.emit("poopEmitted");
  },

  poopCleaned: () => {
    petActions.emitter.emit("poopCleaned");
  },

  sleepStart: () => {
    petActions.emitter.emit("sleepStart");
  },

  sleepEnd: () => {
    petActions.emitter.emit("sleepEnd");
  },

  onPoopCleaned: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("poopCleaned", callback);
  },

  onSoapUsed: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("soapUsed", callback);
  },

  onBallPlayed: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("ballPlayed", callback);
  },

  onFoodEaten: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("foodEaten", callback);
  },

  onPoopEmitted: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("poopEmitted", callback);
  },

  onSleepStart: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("sleepStart", callback);
  },

  onSleepEnd: (callback: () => void): Phaser.Events.EventEmitter => {
    return petActions.emitter.on("sleepEnd", callback);
  },
};
